var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ParticipantTable } from '../../../ui/components/participant-table';
import { useMissionsTranslation } from '../../../ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import AddIcon from '@mui/icons-material/Add';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import SendIcon from '@mui/icons-material/Send';
import { Box, Button, Divider } from '@mui/material';
import React from 'react';
import { EmptyTableView } from './components/EmptyTableView';
import { ToolbarAdmin } from './components/toolbar';
import { useAdminParticipantTableColumns } from './hooks';
export const ShiftRosterTableAdmin = ({ numberOfRequiredParticipants, readonly, totalApprovedRequests, approvedRequests, missionStatus, isShiftEnded, onHandleWithdraw, onSendMessageToVolunteers, onRowClick, onPromoteShift, onAddVolunteer, }) => {
    const { t } = useMissionsTranslation();
    const handleWithdraw = (selectedRows, handleSelectReset) => {
        showFormDialog({
            title: t('shifts.pendingRequest.withdrawShift.toolbarWithdrawConfirmTitle'),
            config: {
                type: 'form',
                children: [
                    {
                        type: 'form.content',
                        html: `<p class="body1">${t('shifts.pendingRequest.withdrawShift.toolbarWithdrawConfirmContent')}</p>`,
                    },
                ],
            },
            onSubmit: () => __awaiter(void 0, void 0, void 0, function* () {
                yield (onHandleWithdraw === null || onHandleWithdraw === void 0 ? void 0 : onHandleWithdraw({
                    shiftId: selectedRows[0].columns.shiftId,
                    shiftParticipations: selectedRows.map((row) => ({
                        shiftParticipantId: row.columns.participantId,
                        shiftParticipationId: row.id,
                    })),
                }));
                handleSelectReset(selectedRows.map((row) => row.id));
            }),
            submitLabel: t('shifts.pendingRequest.withdrawShift.toolbarWithdrawConfirmButtonText'),
        });
    };
    const disableAddVolunteer = totalApprovedRequests >= numberOfRequiredParticipants || missionStatus === 'draft';
    return (React.createElement(ParticipantTable, { allRows: approvedRequests, onRowClick: onRowClick, totalRows: totalApprovedRequests, columns: useAdminParticipantTableColumns(), readonly: readonly, showTableHead: false, showTableBorder: false, showToolbarBorder: false, toolbar: (params) => (React.createElement(ToolbarAdmin, { participantNumber: totalApprovedRequests, totalRequiredParticipantNumber: numberOfRequiredParticipants, multiSelect: params.multiSelect, actions: React.createElement(React.Fragment, null,
                React.createElement(Box, { sx: {
                        display: 'flex',
                        gap: { xs: 2, md: 4 },
                        flexGrow: { xs: 1, md: 0 },
                        flexWrap: 'wrap',
                        width: { xs: '100%', md: 'auto' },
                    } },
                    React.createElement(Button, { sx: {
                            width: { xs: '100%', md: 'auto' },
                        }, startIcon: React.createElement(AddIcon, null), variant: 'text', disabled: disableAddVolunteer, onClick: onAddVolunteer, "data-test": 'add-volunteer-button' }, t('shifts.addVolunteers')),
                    React.createElement(Divider, { orientation: 'vertical', sx: {
                            height: 'inherit',
                            display: { xs: 'none', md: 'block' },
                        } }),
                    React.createElement(Button, { sx: { width: { xs: '100%', md: 'auto' } }, disabled: params.selectedRows.length === 0, startIcon: React.createElement(RemoveCircleOutlineIcon, null), onClick: () => handleWithdraw(params.selectedRows, params.handleSelectReset), "data-test": 'withdraw-button' }, t('missions.missionDetails.withdraw')),
                    React.createElement(Button, { sx: { width: { xs: '100%', md: 'auto' } }, disabled: params.selectedRows.length === 0, startIcon: React.createElement(SendIcon, null), variant: 'outlined', onClick: () => onSendMessageToVolunteers(params.selectedRows.map((row) => row.columns.participantId)), "data-test": 'send-message-button' }, t('missions.missionDetails.sendMessage')))) })), tableRowActions: (row, handleSelectReset) => (React.createElement(Button, { startIcon: React.createElement(RemoveCircleOutlineOutlinedIcon, null), onClick: (event) => {
                event.stopPropagation();
                handleWithdraw([row], handleSelectReset);
            }, "data-test": 'withdraw-button' }, t('missions.missionDetails.withdraw'))), emptyTableView: React.createElement(EmptyTableView, { missionStatus: missionStatus, isShiftEnded: isShiftEnded, onPromoteShift: onPromoteShift }) }));
};
